import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";

export function initCategoriesSlider() {
  const swiper = document.querySelector(".categories-slider__swiper");

  if (!swiper) return;

  new Swiper(swiper, {
    modules: [Navigation],
    slidesPerView: 2,
    spaceBetween: 20,
    speed: 600,
    navigation: {
      prevEl: ".categories-slider__btn-prev",
      nextEl: ".categories-slider__btn-next",
    },
    breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      900: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1300: {
        slidesPerView: 7,
        spaceBetween: 20,
      },
      1800: {
        slidesPerView: 9,
        spaceBetween: 25,
      },
    },
  });
}
